import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/hvac';
export function Testimonials() {
  return <section className="bg-white px-4 py-5 sm:py-7" data-id="element-189" data-mp="3krp59519wxqc">
      <div className="mx-auto max-w-4xl" data-id="element-190" data-mp="3fze4jzypl7wq">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-191" data-mp="3fyco1fyxbt7m">
          What HVAC technicians are saying
        </h2>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-192" data-mp="3ayqb77n0cezc">
          {testimonials.map((testimonial, i) => <li key={testimonial.name} className={`flex flex-col rounded-lg border border-navy/10 bg-off p-3 shadow-sm ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-193" data-mp="31zwab52n92fz" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-194" data-mp="2s39pggabibdy">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-diag text-diag" aria-hidden="true" data-id="element-195" data-mp="qac415ivel31" data-mpi={star} />)}
              </div>
              <p className="mt-1.5 text-sm font-medium leading-snug text-charcoal/85" data-id="element-196" data-mp="m5kjyikz0j9s">
                “{testimonial.quote}”
              </p>
              <p className="mt-auto pt-2 text-sm font-extrabold text-navy" data-id="element-197" data-mp="79bpduc0yu3p">
                {testimonial.name}
              </p>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-hvac" data-id="element-198" data-mp="c8okf2d1v7hd">
                {testimonial.role}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}